import { AxiosError } from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { addToasts, createPolygon, getTeamReps, selectTeam } from '../../redux';
import { getLicensingRestrictions } from '../../redux/helpers';
const makeToasts = (response) => ([
    {
        type: 'success',
        message: `Polygon #${response.data.polygon.polygon_id} is created.`,
    },
]);
function* handleCreatePolygon({ payload }) {
    const { teamId, boundaries, repIds, callback } = payload;
    try {
        const response = (yield call(Api.createPolygon, teamId, { boundary: boundaries, reps: repIds }));
        yield put(createPolygon.success(response.data));
        yield put(addToasts(makeToasts(response.data)));
        yield call(callback, response.data.data.polygon);
    }
    catch (error) {
        yield put(createPolygon.failure(error));
        if (error instanceof AxiosError && error.response?.data?.data) {
            const response = error.response;
            if (response.data.data.polygon) {
                yield put(addToasts(makeToasts(response.data)));
                yield call(callback, response.data.data.polygon, getLicensingRestrictions({
                    [response.data.data.polygon.polygon_id]: response.data.data.polygon.licensing_information,
                }));
            }
        }
    }
    finally {
        const { team } = (yield select(selectTeam));
        if (team?.id) {
            yield put(getTeamReps.request({ teamId: team.id }));
        }
    }
}
export default handleCreatePolygon;
